import styles from './Icon.module.scss';

import cx from 'classnames';
import React, { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { ICON_TEST_ID } from './Icon.const';

export enum IconType {
  ARROW_RIGHT = 'arrow-right',
  CHEVRON_DOWN = 'chevron-down',
  CHEVRON_LEFT = 'chevron-left',
  CHEVRON_RIGHT = 'chevron-right',
  CHEVRON_UP = 'chevron-up',
  CLOSE = 'close',
  PURPLE_CHEVRON_UP = 'purple-chevron-up',
  PURPLE_CHEVRON_DOWN = 'purple-chevron-down',
}

export interface IIconProps extends React.HTMLAttributes<HTMLDivElement> {
  type?: IconType;
  title?: string;
  children?: never;
}

const IconPaths = {
  [IconType.CHEVRON_DOWN]: (
    <path d="M3 10L10 17L17 10" stroke="#5A5A5A" strokeWidth="2" strokeLinecap="round" />
  ),
  [IconType.PURPLE_CHEVRON_DOWN]: (
    <path d="M3 10L10 17L17 10" stroke="#221144" strokeWidth="2" strokeLinecap="round" />
  ),
  [IconType.CHEVRON_LEFT]: <path d="M10 3L3 10L10 17" />,
  [IconType.CHEVRON_RIGHT]: <path d="M10 3L17 10L10 17" />,
  [IconType.CHEVRON_UP]: <path d="M3 10L10 3L17 10" stroke="#5A5A5A" strokeWidth="2" strokeLinecap="round" />,
  [IconType.PURPLE_CHEVRON_UP]: (
    <path d="M3 10L10 3L17 10" stroke="#221144" strokeWidth="2" strokeLinecap="round" />
  ),
  [IconType.CLOSE]: (
    <>
      <path d="M3 17L17 3" />
      <path d="M3 3L17 17" />
    </>
  ),
  [IconType.ARROW_RIGHT]: (
    <>
      <path
        d="M7 1L12.8795 6.71733C12.9566 6.79226 13 6.89396 13 7C13 7.10604 12.9566 7.20774 12.8795 7.28267L7 13"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M13 7L1 7" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
    </>
  ),
};

export const Icon = forwardRef<HTMLDivElement, IIconProps>(({ className, type, title, ...props }, ref) => {
  if (!type) return null;

  const { t } = useTranslation();

  return (
    <div ref={ref} data-testid={ICON_TEST_ID.icon} className={cx(styles.icon, type, className)} {...props}>
      <svg
        className={styles.iconSvg}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        strokeWidth="2"
        strokeLinecap="round"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>{title || t(getTitleByIconType(type) as any)}</title>
        {IconPaths[type]}
      </svg>
    </div>
  );
});

export const getTitleByIconType = (type: IconType): string => {
  switch (type) {
    case IconType.CHEVRON_LEFT:
      return 'previous';
    case IconType.CHEVRON_RIGHT:
    case IconType.ARROW_RIGHT:
      return 'next';
    default:
      return type as string;
  }
};
